import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IActiveShifts } from '../../models/dashboard/jobs/getActiveShifts.model';

interface ActiveShiftsState {
  jobData: IActiveShifts[];
  totalPages: number;
  totalElements: number;
  numberOfElements: number;
  first: boolean;
  last: boolean;
}

const initialState: ActiveShiftsState = {
  jobData: [],
  totalPages: 0,
  totalElements: 0,
  numberOfElements: 0,
  first: false,
  last: false,
};

const jobActiveShiftSlice = createSlice({
  name: 'activeShifts',
  initialState,
  reducers: {
    getJobActiveShift(state, action: PayloadAction<ActiveShiftsState>) {
      return { ...state, ...action.payload };
    },
  },
});

export const jobActiveShiftActions = jobActiveShiftSlice.actions;
export default jobActiveShiftSlice.reducer;
